import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ProposalForm from '../proposal_form/ProposalForm';
import {
	proposalsRestCrudThunksForBuyer,
	proposalsRestCrudThunksForSupplier,
} from '../../thunks/proposals_thunks';
import { EditPage } from '../edit_page/EditPage';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	requestsForProposalRestCrudThunksForBuyer,
	requestsForProposalRestCrudThunksForSupplier,
} from '../../thunks/requests_for_proposal_thunks';
import {
	biddersRestCrudThunksForBuyer,
	biddersRestCrudThunksForSupplier,
} from '../../thunks/bidders_thunks';
import { isInternalTech } from '../../utils/AuthUtils';
import { currentUser } from '../../mock_data/mocks';

const queryString = require('qs');

class EditProposalPage extends React.Component<any, any> {
	componentDidMount() {
		const { location, match, getProposal } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const proposalId = queryParams.proposalId;
		getProposal(proposalId);
	}

	render() {
		const {
			location,
			history,
			proposal,
			fetching,
			getBidders,
			getRequestForProposal,
			userType,
			currentUser,
		} = this.props;

		const formData = {
			...proposal,
		};
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const requestForProposalId = queryParams.requestForProposalId;
		const isBuyerOrInternalTech = userType === ROLE_TYPES.BUYER || isInternalTech(currentUser);

		return [
			<LogOnMountWithStandardEventProperties eventType="visited edit proposal page" />,
			<EditPage
				title="Edit Proposal"
				formComponentProps={{
					formData: formData,
					onSuccess: (rec) => {
						Promise.all([
							getBidders({ requestForProposalId }, 'RFP_DETAIL_BIDDERS'),
							getRequestForProposal(requestForProposalId),
						]);
						history.push(
							`/${userType}/${
								isBuyerOrInternalTech ? 'requestsForProposal' : 'opportunities'
							}/detail/${rec.requestForProposal.id}/${
								isBuyerOrInternalTech ? 'compareBids' : 'details'
							}`
						);
					},
				}}
				fetching={fetching}
				FormComponent={ProposalForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	proposal: state.proposals.detail,
	fetching: state.proposals.fetching,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getProposal: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? proposalsRestCrudThunksForSupplier.readOne(id)
				: proposalsRestCrudThunksForBuyer.readOne(id)
		),
	getRequestForProposal: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? requestsForProposalRestCrudThunksForSupplier.readOne(id)
				: requestsForProposalRestCrudThunksForBuyer.readOne(id)
		),
	getBidders: (params, targetCollectionName, pagination, sorting, filters) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? biddersRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
				: biddersRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
		),
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(EditProposalPage))
);
